<template>
  <div style="height: 1px;" :class="`prikazPdfDiv scale-${(scale*100)}`">
    <div v-if="source" :style="`width: ${width}; height: ${height}`">
      <div ref="top">
        <div class="header">
          <div class="ml-6" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{ title }}</div>
          <div style="min-width: 100px; text-align: center;">
            <el-button type="info" circle @click="minusClick"><i class="fa fa-minus"></i></el-button>
            {{(scale * 100).toFixed(0)}}
            <el-button type="info" circle @click="plusClick"><i class="fa fa-plus"></i></el-button>
          </div>
          <div style="text-align: right;min-width: 100px;" class="mr-3">
            <el-button type="info" circle @click="downloadPdf()"><i class="fa fa-download"></i></el-button>
            <el-button type="info" circle @click="printPDFDialog()"><i class="fa fa-print"></i></el-button>
          </div>
        </div>
        <vue-pdf-embed
          ref="pdfEmbed"
          :source="pdfSource"
          @rendered="rendered"
          :scale="scale"
          :key="scaleKey"
        />
      </div>
    </div>
    <p v-else>Ni PDF podatkov.</p>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import {Button} from 'element-ui'
import {PrenosDatoteke} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke'

export default {
  name: 'PrikazPdf',
  mixins: [PrenosDatoteke],
  components: {
    VuePdfEmbed,
    [Button.name]: Button
  },
  props: {
    source: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    showAllPages: {
      type: Boolean,
      default: false
    },
    noLastPageButton: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    noDownload: {
      type: Boolean,
      default: false
    },
    emitDownload: {
      type: Boolean,
      default: false
    },
    expandOption: {
      type: Boolean,
      default: true
    },
    dialog: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageCount: 1,
      pageCurr: 1,
      expanded: false,
      zoomDialog: true,
      scaleKey: 1,
      scale: 1,
      scaleList: [0.25, 0.5, 0.75, 1, 1.1, 1.25, 1.5, 2, 3, 4, 5]
    }
  },
  computed: {
    pdfSource () {
      let prefix = ''
      if (this.type === 'base64') prefix = 'data:application/pdf;base64,'

      return prefix + this.source + ' '.repeat(this.scaleKey)
    },
    scalePlusDisabled () {
      return this.scaleList.indexOf(this.scale) === (this.scaleList.length - 1)
    },
    scaleMinusDisabled () {
      return this.scaleList.indexOf(this.scale) === 0
    }
  },
  created () {
    if (this.$screen.width > 720) {
      this.scale = 1.1
    }
    if (this.$screen.width > 991) {
      this.scale = 1.25
    }
    if (this.$screen.width < 650) {
      this.scale = 0.75
    }
    if (this.$screen.width < 500) {
      this.scale = 0.5
    }
  },
  methods: {
    plusClick () {
      let index = this.scaleList.indexOf(this.scale)
      index++
      if (index < this.scaleList.length) {
        this.scale = this.scaleList[index]
      }
      this.afterPlusMinusClick()
    },
    minusClick () {
      let index = this.scaleList.indexOf(this.scale)
      index--
      if (index > -1) {
        this.scale = this.scaleList[index]
      }
      this.afterPlusMinusClick()
    },
    afterPlusMinusClick (counter = 0) {
      counter++
      if (counter < 10) {
        this.scaleKey++
        setTimeout(() => {
          if (this.$refs.pdfEmbed.document === null) {
            this.afterPlusMinusClick(counter)
          }
        }, 100)
      }
    },
    rendered () {
      this.pageCount = this.$refs.pdfEmbed.pageCount
      this.$emit('rendered')
    },
    printPDFDialog () {
      const byteCharacters = atob(this.source)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      // Create a Blob from the array buffer
      const blob = new Blob([byteArray], {type: 'application/pdf'})
      // Create a URL for the Blob and open it in a new window
      const pdfUrl = URL.createObjectURL(blob)
      const printWindow = window.open(pdfUrl)
      printWindow.onload = function () {
        printWindow.focus() // Ensure the new window is in focus
        printWindow.print() // Trigger the print dialog
      }
    },
    async downloadPdf () {
      if (this.emitDownload) {
        this.$emit('download', this.pdfSource)
        return
      }

      let title = this.title ? this.title + '.pdf' : 'Dokument.pdf'
      try {
        await this.downloadFile(this.pdfSource, title)
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    downloadFile (href, download) {
      this.PrenesiDatoteko(href, download)
    },
    scrollToTop () {
      this.$refs.top.scrollIntoView({ behavior: 'smooth' })
    }
  },
  watch: {
    showAllPages: {
      immediate: true,
      handler (newValue) {
        if (newValue) this.pageCurr = null
        else this.pageCurr = this.page
      }
    },
    page (newValue) {
      this.pageCurr = newValue
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/PrikazPdf.vue